<template>
  <div>
    <Aguarde :show="httpSend"></Aguarde>
    <div class="row border-bottom border-secondary mb-1">
      <div class="col-12">
        <b-form @submit.prevent="listNotas()">
          <div class="row">
            <div class="col-md-6">
              <b-form-group label="Prestador" label-for="rel_empresa">
                <multiselect
                    v-model="curretEmpresa"
                    track-by="pes_nome"
                    label="pes_nome"
                    id="rel_empresa"
                    placeholder="Todos"
                    @select="selectEmpresa"
                    @remove="removeEmpresa"
                    @search-change="pesquisarEmpresas"
                    :close-on-select="true"
                    :options="list_empresas"
                    :selectLabel="'Pressione enter para selecionar'"
                    :selectedLabel="'Selecionado'"
                    :deselectLabel="'Pressione enter para remover'"
                    :searchable="true"
                    :internal-search="false"
                    :openDirection="'bottom'"
                    :tagPosition="'bottom'">
                  <template slot="option" slot-scope="props">
                    <div class="option__desc">
          <span class="option__title">
            <b>Código: </b>{{ props.option.eco_codigo }}
            <br><b>Razão Social: </b>{{ props.option.pes_nome }}
            <br><b>Nome Fantasia: </b>{{ props.option.eco_nome_fantasia }}
            <br><b>Tipo de Empresa: </b>{{ props.option.pes_tipopessoa | tipoPessoaTabNumero }}
            <br><b>Tributação Especial: </b>{{ props.option.eco_tributacao | tributacaoPessoa }}
          </span>
                    </div>
                  </template>
                  <span slot="noOptions">Faça a pesquisa por código, razão social, nome fantasia ou CNPJ</span>
                  <span slot="noResult">Empresa não localizada ou não liberada para o seu usuário.
          <br> Informe Código, Razão Social, Nome Fantasia ou CNPJ
          </span>
                </multiselect>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Tributação" label-for="sep_exigibilidade_iss">
                <select id="sep_exigibilidade_iss"
                        v-model="filtro.sep_exigibilidade_iss"
                        class="custom-select" type="text">
                  <option value="">Todos</option>
                  <option value="1">Exigível</option>
                  <option value="2">Não Incidência</option>
                  <option value="3">Isenção</option>
                  <option value="5">Imune</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Situação" label-for="not_cancelada">
                <select id="not_cancelada"
                        v-model="filtro.not_cancelada"
                        class="custom-select" type="text">
                  <option value="">Todos</option>
                  <option value="1">Normal</option>
                  <option value="2">Cancelada</option>
                </select>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group
                  label="Nome/Razão Tomador"
                  label-for="fsep_razao_social_tomador">
                <input
                    id="fsep_razao_social_tomador"
                    v-model="filtro.sep_razao_social_tomador"
                    type="text"
                    maxlength="20"
                    class="form-control"
                    placeholder=" ">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="CPF/CNPJ do Tomador">
                <the-mask class="form-control" v-model="filtro.sep_cpf_cnpj_tomador"
                          :mask="['###.###.###-##', '##.###.###/####-##']"/>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Exigibilidade" label-for="sep_municipio_incidencia">
                <select id="sep_municipio_incidencia"
                        v-model="filtro.sep_municipio_incidencia"
                        class="custom-select" type="text">
                  <option value="">Todos</option>
                  <option v-bind:value="'='+entidade.mun_codigo">No Município</option>
                  <option v-bind:value="'<>'+entidade.mun_codigo">Fora do Município</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="ISS Retido" label-for="sep_iss_retido">
                <select id="sep_iss_retido"
                        v-model="filtro.sep_iss_retido"
                        class="custom-select" type="text">
                  <option value="">Todos</option>
                  <option value="S">Sim</option>
                  <option value="N">Não</option>
                </select>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group
                  label="Emissão Incial"
                  label-for="not_emissao_incial">
                <input
                    id="not_emissao_incial"
                    v-model="filtro.not_emissao_incial"
                    type="date"
                    maxlength="10"
                    class="form-control"
                    placeholder="Dia/Mês/Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Emissão Final"
                  label-for="not_emissao_final">
                <input
                    id="not_emissao_final"
                    v-model="filtro.not_emissao_final"
                    type="date"
                    maxlength="10"
                    class="form-control"
                    placeholder="Dia/Mês/Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Competência Inicial"
                  label-for="sep_competencia_inicial">
                <input
                    id="sep_competencia_inicial"
                    v-model="filtro.sep_competencia_inicial"
                    v-mask="'##/####'"
                    type="text"
                    maxlength="7"
                    class="form-control"
                    placeholder="Mês/Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Competência Final"
                  label-for="sep_competencia_final">
                <input
                    id="sep_competencia_final"
                    v-model="filtro.sep_competencia_final"
                    v-mask="'##/####'"
                    type="text"
                    maxlength="7"
                    class="form-control"
                    placeholder="Mês/Ano">
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Ordenação" label-for="nota_pagina">
                <select id="nota_pagina"
                        @change="listNotas()"
                        v-model="filtro.ordenacao"
                        class="custom-select" type="text">
                  <option value="n.not_emissao desc">Data de Emissão ↓</option>
                  <option value="n.not_emissao">Data de Emissão ↑</option>
                  <option value="sp.sep_valor desc">Valor da Nota ↓</option>
                  <option value="sp.sep_valor">Valor da Nota ↑</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Notas por Página" label-for="nota_pagina">
                <select id="nota_pagina"
                        @change="listNotas"
                        v-model="filtro.nota_pagina"
                        class="custom-select" type="text">
                  <option value="10">10/Pág.</option>
                  <option value="30">30/Pág.</option>
                  <option value="50">50/Pág.</option>
                  <option value="80">80/Pág.</option>
                  <option value="100">100/Pág.</option>
                  <option value="200">200/Pág.</option>
                  <option value="500">500/Pág.</option>
                  <option value="800">800/Pág.</option>
                  <option value="1000">1000/Pág.</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="'" class="text-white">
                <button type="submit"
                        class="btn btn-label btn-primary mr-3"><i
                    class="bx bx-search label-icon"></i>
                  Consultar
                </button>
                <button type="button"
                        @click="geraRelatorio()"
                        class="btn btn-label btn-light "><i
                    class="bx bx-printer label-icon"></i>
                  Gerar Relatório
                </button>
              </b-form-group>
            </div>
          </div>
        </b-form>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div v-show="reposta.http" role="alert" aria-live="polite" aria-atomic="true"
             class="alert alert-primary text-center my-1">
          Gerando Relatório
          <br><i class="bx bx-loader bx-spin font-size-18 align-middle mr-2"></i> Aguarde
        </div>
        <div v-show="reposta.status === true" role="alert" aria-live="polite"
             aria-atomic="true"
             class="alert alert-success my-1">
          Relatório gerado com sucesso
          <br><a v-bind:href="relLink" target="_blank" class="alert-link"><i class="mdi mdi-download mr-2"></i>
          Clique
          aqui para baixar o
          relatório </a>
        </div>
        <div v-show="reposta.status === false" role="alert" aria-live="polite" aria-atomic="true"
             class="alert alert-danger my-1">
          <i class="mdi mdi-alert mr-2"></i> Não foi possível gerar o relatório.
          <br> {{ reposta.mensagem }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <TableNotasAdmin :resumo="resumo" :list_notas="notas"/>
        <div v-show="notas && notas.length > 0" class="row">
          <div class="col-lg-12">
            <paginate
                v-model="filtro.pagina"
                :page-count="total_paginas"
                :page-range="3"
                :margin-pages="3"
                :click-handler="proximaPagina"
                :prev-text="'Página anterior'"
                :next-text="'Próxima página'"
                :prev-link-class="'page-link'"
                :next-link-class="'page-link'"
                :page-link-class="'page-link'"
                :container-class="'pagination pagination-rounded justify-content-center mt-4'"
                :page-class="'page-item'">
            </paginate>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import {TheMask} from 'vue-the-mask'
import Paginate from 'vuejs-paginate'
import {autocompleteEmpresas} from "@/api/geral/autocomplete";
import Aguarde from "@/components/widgets/aguarde.vue";
import moment from "moment/moment";
import {listNotasFiscaisAdmin} from "@/api/admin/gestao/notas_fiscais";
import TableNotasAdmin from "@/router/views/admin/nfse/components/table-nfse.vue";
import {openRelatorioJava, relNotasFiscais} from "@/api/relatorio_java/relatorios";

export default {
  components: {
    Paginate,
    TableNotasAdmin,
    Aguarde,
    Multiselect,
    TheMask
  },
  data() {
    return {
      notas: [],
      resumo: {},
      total_paginas: 0,
      isLoading: false,
      httpSend: false,
      relLink: '',
      user: null,
      curretEmpresa: null,
      list_empresas: [],
      empresas: [],
      filtro: {
        eco_codigo: null,
        sep_competencia_inicial: "",
        sep_competencia_final: "",
        not_emissao_incial: moment().subtract(90, "days").format('YYYY-MM-DD'),
        not_emissao_final: moment().format('YYYY-MM-DD'),
        sep_exigibilidade_iss: "",
        not_cancelada: "",
        sep_municipio_incidencia: "",
        sep_iss_retido: "",
        sep_cpf_cnpj_tomador: "",
        sep_razao_social_tomador: "",
        ordenacao: "n.not_emissao desc",
        pagina: 1,
        nota_pagina: "10"
      },
      reposta: {
        http:false,
        status: null,
        mensagem: '',
      },
    };
  },
  computed: {
    entidade: {
      get: function () {
        return this.$store.state.auth.currentEntidade;
      },
    },
  },
  created() {
    this.listNotas();
  },
  methods: {
    removeEmpresa() {
      this.filtro.eco_codigo = 0
    },
    selectEmpresa(empresa) {
      if (empresa) {
        this.filtro.eco_codigo = empresa.eco_codigo
      } else {
        this.filtro.eco_codigo = 0
      }
    },
    pesquisarEmpresas(search) {
      if (search && search.length > 1) {
        this.isLoading = true;
        autocompleteEmpresas({query: search}).then(response => {
          if (response.status) {
            if (response.dados) {
              this.list_empresas = response.dados
            }
          }
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          this.isLoading = false;
        })
      }
    },
    proximaPagina(pageNum) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.filtro.pagina = pageNum;
      this.listNotas()
    },
    listNotas() {
      this.reposta.status = null;
      this.httpSend = true;
      listNotasFiscaisAdmin(this.filtro).then(result => {
        this.resumo = result.dados.resumo;
        this.total_paginas = result.dados.paginas;
        this.notas = result.dados.notas;
        this.list_avulsas = result.dados.avulsas;
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    detalhe(nota) {
      this.$router.push({
        name: 'admin-liberacao-pessoa-detalhe',
        params: {tps_hash: nota.tps_hash}
      })
    },
    geraRelatorio() {
      this.reposta.status = null;
      this.reposta.http = true;
      relNotasFiscais(this.filtro).then(result => {
        const rs = result.response;
        if (rs.status) {
          this.reposta.status = true;
          this.relLink = openRelatorioJava(rs.data, "Relatório de Notas Fiscais Emitidas");
        } else {
          this.reposta.status = false;
          this.reposta.mensagem = rs.mensage;
        }
      }).catch(error => {
        this.reposta.status = false;
        this.reposta.mensagem = error;
        console.log(error)
      }).finally(() => {
        this.reposta.http = false;
      })
    },
  }
};
</script>

